var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageBase',{staticClass:"content-background-forms",scopedSlots:_vm._u([{key:"navigation",fn:function(){return [_c('D4DNavigation')]},proxy:true}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }